(() => {
  'use strict';
  if (window.WerlarCartPage) return;
  const controllers = new WeakMap();
  const roots = scope => [...(scope.matches?.('[data-wr-cart-page]') ? [scope] : []), ...scope.querySelectorAll('[data-wr-cart-page]')];
  function initialize(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    let busy = false;
    const options = { signal: controller.signal };
    async function change(input, key, line, quantity) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || window.Werlar?.root || '/'}cart/change.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...(key ? { id: key } : { line: Number(line) }), quantity: Math.max(0, Number.parseInt(quantity, 10) || 0) })
        });
        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'The cart could not be updated.');
        }
        window.location.reload();
      } catch (error) {
        if (input) input.value = input.defaultValue;
        window.alert(error.message || 'The cart could not be updated. Please try again.');
        busy = false;
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
      }
    }
    root.addEventListener('click', event => {
      const step = event.target.closest('[data-cart-step]');
      const remove = event.target.closest('.wr-cart-page-remove');
      if (!step && !remove) return;
      event.preventDefault();
      const control = step || remove;
      const input = control.closest('.wr-cart-row')?.querySelector('.wr-cart-page-qty__input');
      if (input) change(input, control.dataset.itemKey, control.dataset.line,
        remove ? 0 : (Number.parseInt(input.value, 10) || 0) + Number(control.dataset.delta));
    }, options);
    root.addEventListener('change', event => {
      const input = event.target.closest('.wr-cart-page-qty__input');
      if (input) change(input, input.dataset.itemKey, input.dataset.line, input.value);
    }, options);
    root.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('.wr-cart-page-qty__input')) {
        event.preventDefault(); event.target.blur();
      }
    }, options);
    root.addEventListener('submit', event => { if (busy) event.preventDefault(); }, options);
  }
  window.WerlarCartPage = {
    init(scope = document) { roots(scope).forEach(initialize); },
    destroy(scope) { roots(scope).forEach(root => { controllers.get(root)?.abort(); controllers.delete(root); }); }
  };
})();
